import { render, staticRenderFns } from "./user-chat.vue?vue&type=template&id=5332371f&scoped=true&"
var script = {}
import style0 from "./user-chat.vue?vue&type=style&index=0&id=5332371f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332371f",
  null
  
)

export default component.exports